export const COLUMN_WIDTH = {
  DATE: 190,
  DELIVERY_STATUS: 200,
} as const
